import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

type ListOfLinksHeaderTextProps = {
    readonly isSideBar: boolean;
    readonly headerText: string;
};

export const ListOfLinksHeaderText = ({
    isSideBar,
    headerText
}: ListOfLinksHeaderTextProps) => {
    const headerTextStyle = [
        isSideBar &&
            css({
                paddingBlockEnd: token("space.200"),
                paddingBlockStart: "15px",
                color: "#42526e",
                margin: `0 0 ${token("space.100")} 0`,
                fontWeight: 500,
                fontSize: token("space.150"),
                lineHeight: 1.5,
                letterSpacing: "1px",
                textTransform: "uppercase",
                width: "100%"
            }),
        !isSideBar &&
            css({
                paddingBlockEnd: "0",
                paddingBlockStart: "0",
                color: "#42526e",
                margin: `0 0 ${token("space.100")} 0`,
                fontWeight: 500,
                fontSize: token("space.150"),
                lineHeight: 1.5,
                letterSpacing: "1px",
                textTransform: "uppercase",
                width: "100%"
            })
    ];
    return <h2 css={headerTextStyle}>{headerText.trim().toUpperCase()}</h2>;
};
